import script from "./OrganizationView.vue?vue&type=script&setup=true&lang=ts"
export * from "./OrganizationView.vue?vue&type=script&setup=true&lang=ts"

import "./OrganizationView.vue?vue&type=style&index=0&id=d6efe8d2&lang=css"

const __exports__ = script;

export default __exports__